<!--sidebar-->
<c-sidebar
  #sidebar1="cSidebar"
  class="d-print-none sidebar sidebar-fixed "
  colorScheme="light"
  id="sidebar1"
  visible
>
  <c-sidebar-header class="">
    <c-sidebar-brand [routerLink]="[]">
	 <svg [class]="{icon: false}" cIcon class="sidebar-brand-full d-none" height="32" name="logo" title="CoreUI Logo"></svg>
      <img cIcon [class]="{icon: false}" src="../../../assets/images/q-dashboard-logo.svg" class="sidebar-brand-full" name="q-logo"  title=" Q Logo"/>
	  <img src="../../../assets/images/q-narrow-logo.svg" class="sidebar-brand-narrow" name="q-logo"  title=" Q Logo"/>
    </c-sidebar-brand>
  </c-sidebar-header>

  <ng-scrollbar pointerEventsMethod="scrollbar" visibility="hover">
    <c-sidebar-nav [navItems]="navItems" dropdownMode="close" compact />
  </ng-scrollbar>

  @if (!sidebar1.narrow) {
    <c-sidebar-footer cSidebarToggle="sidebar1" class="d-none d-lg-flex" toggle="unfoldable" style="cursor: pointer;">
      <button cSidebarToggler aria-label="Toggle sidebar fold"></button>
    </c-sidebar-footer>
  }
</c-sidebar>

<!--main-->
<div class="wrapper d-flex flex-column min-vh-100">
  <!--app-header-->
  <app-default-header
    [cShadowOnScroll]="'sm'"
    class=" d-print-none header header-sticky p-0 shadow-sm"
    position="sticky"
    sidebarId="sidebar1"
  />
  <!--app-body-->
  <div class="body flex-grow-1 dashboard-page">
    <router-outlet />
   </div>
  <!--app footer-->
  <app-default-footer class="dashboard-footer"/>
</div>
